/* @flow */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import Responsive from 'app/components/responsive/Responsive';
import FilterBox from 'app/components/sportsFilters/FilterBox';
import MobileFilterBox from 'app/components/sportsFilters/MobileFilterBox';
import { fetchCompetitionsList } from 'app/actions/globalLeaderboardActions';

type Props = {
  activeSport: ?string,
  activeSubCategory: ?string,
  isLoading?: boolean,
  namespace: string,
  onFetch: () => void,
  showAll?: boolean,
  spartan: boolean,
  sportsList: Array<Object>,
};

class GlobalLeaderboardSportsFilterBox extends Component<Props> {
  props: Props;

  static defaultProps = {
    isLoading: false,
    showAll: false,
  };

  componentDidMount() {
    const { onFetch, sportsList } = this.props;

    if (sportsList.length === 0) {
      onFetch();
    }
  }

  render() {
    const {
      activeSport,
      activeSubCategory,
      namespace,
      isLoading,
      showAll,
      sportsList,
      spartan,
    } = this.props;

    return (
      <Responsive desktop>
        {isDesktop =>
          (isDesktop ? (
            <FilterBox
              activeSport={activeSport}
              activeSubCategory={activeSubCategory}
              isLoading={isLoading}
              namespace={namespace}
              showAll={showAll}
              showSubCategories
              sportsList={sportsList}
              spartan={spartan}
            />
          ) : (
            <MobileFilterBox
              activeSport={activeSport}
              activeSubCategory={activeSubCategory}
              isLoading={isLoading}
              namespace={namespace}
              showAll={showAll}
              showSubCategories
              sportsList={sportsList}
            />
          ))
        }
      </Responsive>
    );
  }
}

const connector = connect(
  null,
  {
    onFetch: fetchCompetitionsList,
  },
);

export default connector(GlobalLeaderboardSportsFilterBox);
